var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocateLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.46,
    height: 20.29,
    viewBox: "0 0 19.46 20.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.507 -4557.738)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-371.507,4560.491v4.256h1.4v-4.256a1.354,1.354,0,0,1,1.352-1.353h4.256v-1.4h-4.256A2.756,2.756,0,0,0-371.507,4560.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.107,4575.275v-4.257h-1.4v4.257a2.756,2.756,0,0,0,2.752,2.753h4.256v-1.4h-4.256A1.353,1.353,0,0,1-370.107,4575.275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.448,4575.275a1.353,1.353,0,0,1-1.351,1.352h-4.257v1.4h4.257a2.756,2.756,0,0,0,2.752-2.753v-4.257h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-354.8,4557.738h-4.257v1.4h4.257a1.353,1.353,0,0,1,1.351,1.353v4.256h1.4v-4.256A2.756,2.756,0,0,0-354.8,4557.738Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-359.231,4569.058l-1.485-1.484,1.485-1.486a.649.649,0,0,0,0-.919.651.651,0,0,0-.92,0l-1.485,1.485-1.484-1.485a.651.651,0,0,0-.92,0,.648.648,0,0,0,0,.919l1.484,1.485-1.485,1.485a.648.648,0,0,0,0,.919.65.65,0,0,0,.919,0l1.485-1.484,1.485,1.484a.65.65,0,0,0,.919,0A.649.649,0,0,0-359.231,4569.058Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocateLocker);
export default __webpack_public_path__ + "static/media/unlocateLocker.441b2a3521fd1772c3fd7fa7114a869d.svg";
export { ForwardRef as ReactComponent };